module.exports = __webpack_public_path__ + "img/CPTemp4.1ced329d.png";